/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Step_AnalyseInputs */

const cs_ebr_step_analyse = /** @type {(inputs: Ebr_Step_AnalyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načtení a analýza`)
};

const en_ebr_step_analyse = /** @type {(inputs: Ebr_Step_AnalyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch & analyse`)
};

/**
* | output |
* | --- |
* | "Fetch & analyse" |
*
* @param {Ebr_Step_AnalyseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_step_analyse = /** @type {((inputs?: Ebr_Step_AnalyseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Step_AnalyseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_step_analyse(inputs)
	return cs_ebr_step_analyse(inputs)
});